import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

/** GET /api-v2/feed answers 400 to a longer `q` (FeedQuery::MAX_Q_LENGTH); the header search caps its input the same. */
export const MAX_SEARCH_LENGTH = 100;

/**
 * The text of the header search applied to My Feed (`/?q=…`, GROWTH-7577), read from the URL on every render so a
 * reload, a back/forward step and a new search from the header all give the same page.
 *
 * @returns {string|null} the trimmed text; null when there is none, it is blank, repeated (`?q=a&q=b`) or too long
 */
const useFeedSearchQuery = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const requested = queryString.parse(search).q;
    if (typeof requested !== "string") return null;

    const text = requested.trim();
    return text !== "" && text.length <= MAX_SEARCH_LENGTH ? text : null;
  }, [search]);
};

export default useFeedSearchQuery;
